import { initializeConnector } from "@web3-react/core";
import { MetaMask } from "@web3-react/metamask";

export const connectMetaMaskWallet = async (connector) => {
	await connector.activate(1);
};

export const [metaMask, hooks] = initializeConnector((actions) => new MetaMask(actions), [1]);
